import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useStyletron } from "baseui";
import Loading from "../../tools/loading.js";
import InspectionsModal from "./inspectionsModal.js";
import { Button } from "baseui/button";
import { ButtonGroup, SIZE } from "baseui/button-group";
import {
  StatefulDataTable,
  StringColumn,
  CustomColumn,
} from "baseui/data-table";
import { Show } from "baseui/icon";

function VehicleList() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [css] = useStyletron();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [inspectionModalOpen, setInspectionModalOpen] = useState(false);
  const [currentRowData, setCurrentRowData] = useState(null);
  const navigate = useNavigate();
  const [steps, setSteps] = React.useState([]);
  const [inventoryOnly, setInventoryOnly] = useState(false);

  const fetchSteps = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/steps`);
      const sortedSteps = response.data.steps
        .map((step) => ({
          id: step.id,
          label: step.step_name,
        }))
        .sort((a, b) => a.id - b.id);

      console.log("sortedSteps", sortedSteps);
      setSteps(sortedSteps);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log("steps", steps);

  const handleViewVehicle = (rowData) => {
    navigate("/vehicleDetails", { state: { data: rowData } });
  };

  const handleModalClose = () => {
    setInspectionModalOpen(false);
    setCurrentRowData(null);
  };

  console.log("data", data);

  const locationMap = {
    S01_Holmes1: "Diberville",
    S05_Montgomery1: "Montgomery",
    S07_Bham1: "Birmingham",
    S09_Douglas1: "Douglasville",
  };

  const formatLocation = (locationString) => {
    return locationMap[locationString] || "Unknown Location";
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/admin/vehicle/list`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  // const rows = data.map((item, index) => ({
  //   id: index,
  //   data: item,
  // }));
  const handleInventoryOnlyClick = () => {
    setInventoryOnly(!inventoryOnly); // Toggle filter on button click
  };

  // Conditionally filter data based on inventoryOnly state
  const filteredData = inventoryOnly
    ? data.filter((item) => item.app_status) // Only include items with an app_status
    : data;

  const rows = filteredData.map((item, index) => ({
    id: index,
    data: item,
  }));

  const columns = [
    CustomColumn({
      title: "View",
      sortable: false,
      mapDataToValue: (data) => data,
      renderCell: (props) => {
        const rowData = props.value;
        return (
          <div>
            <Show
              style={{ color: "green" }}
              size={30}
              onClick={() => handleViewVehicle(rowData)}
            >
              Edit
            </Show>
          </div>
        );
      },
    }),
    // StringColumn({
    //   title: "Stock Number",
    //   mapDataToValue: (data) => data.stock,
    // }),
    // StringColumn({
    //   title: "Year",
    //   mapDataToValue: (data) => data.year,
    // }),
    // StringColumn({
    //   title: "Make",
    //   mapDataToValue: (data) => data.make,
    // }),
    // StringColumn({
    //   title: "Model",
    //   mapDataToValue: (data) => data.model,
    // }),
    // StringColumn({
    //   title: "VIN",
    //   mapDataToValue: (data) => data.vin,
    // }),
    // StringColumn({
    //   title: "Status",
    //   mapDataToValue: (data) => data.status,
    // }),
    // StringColumn({
    //   title: "app_status",
    //   mapDataToValue: (data) => {
    //     const status = steps.find((step) => step.id === data.app_status);
    //     return status ? status.label : data.app_status; // If status is found, return step_name, else fallback to app_status
    //   },
    // }),
    // StringColumn({
    //   title: "Location",
    //   mapDataToValue: (data) => formatLocation(data.location),
    // }),
    StringColumn({
      title: "Stock Number",
      mapDataToValue: (data) => data.stock || "", // Fallback to empty string if data.stock is null or undefined
    }),
    StringColumn({
      title: "Year",
      mapDataToValue: (data) => data.year || "", // Ensure it's never null or undefined
    }),
    StringColumn({
      title: "Make",
      mapDataToValue: (data) => data.make || "", // Fallback to empty string if data.make is null or undefined
    }),
    StringColumn({
      title: "Model",
      mapDataToValue: (data) => data.model || "", // Ensure it's never null or undefined
    }),
    StringColumn({
      title: "VIN",
      mapDataToValue: (data) => data.vin || "", // Ensure it's never null or undefined
    }),
    StringColumn({
      title: "Status",
      mapDataToValue: (data) => data.status || "", // Fallback to empty string if data.status is null or undefined
    }),
    StringColumn({
      title: "app_status",
      mapDataToValue: (data) => {
        const status = steps.find((step) => step.id === data.app_status);
        return status ? status.label : ""; // Fallback to empty string if status is null or undefined
      },
    }),
    StringColumn({
      title: "Location",
      mapDataToValue: (data) => formatLocation(data.location) || "", // Ensure it's never null or undefined
    }),

    CustomColumn({
      title: "Inspections",
      sortable: false,
      mapDataToValue: (data) => data,
      renderCell: (props) => {
        const rowData = props.value;
        return (
          <>
            <ButtonGroup size={SIZE.mini}>
              <Button
                onClick={() => {
                  setInspectionModalOpen(true);
                  setCurrentRowData(rowData);
                }}
              >
                View Inspections
              </Button>
            </ButtonGroup>
          </>
        );
      },
    }),
  ];

  return (
    <div className={css({ height: "100vh" })}>
      <div
        className={css({
          height: "90vh",
          display: "flex",
          flexDirection: "column",
        })}
      >
        <Button
          className={css({
            width: "10rem",
            position: "absolute",
            padding: ".5rem",
            alignSelf: "flex-end",
            marginRight: "10rem",
            marginTop: ".5rem",
          })}
          onClick={handleInventoryOnlyClick}
        >
          {inventoryOnly ? "Show All" : "Inventory Only"}
        </Button>
        <p
          className={css({
            alignSelf: "flex-end",
            color: inventoryOnly ? "red" : "black",
            position: "absolute",
            marginLeft: "60rem",
            right: "3rem",
          })}
        >
          {inventoryOnly ? " Inventory Only" : "All Vehicles"}
        </p>
        <StatefulDataTable columns={columns} rows={rows} />
      </div>

      {currentRowData && (
        <InspectionsModal
          isOpen={inspectionModalOpen}
          handleModalClose={handleModalClose}
          rowData={currentRowData}
        />
      )}
    </div>
  );
}

export default VehicleList;
